export default function getListObjByKey(listObj, key, keyReq, keyRes) {
  for (const obj of listObj) {
    if (obj[keyReq] == key) {
      return obj[keyRes];
    }
  }
  return "";
}
